/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHomeContext } from "../../contexts/HomeContext";
import Container from "../Container";
import Text from "../Text";
import Card from "../Card";
import { Chart } from "primereact/chart";
import { AssetMainType } from "../../models/asset";

export default function AssetWalletSubgroupCard() {
    const homeContext = useHomeContext();

    const documentStyle = getComputedStyle(document.documentElement);
    const chartData = {
        labels: [
            'Títulos privados', 
            'Poupança', 
            'Debênture', 
            'Tesouro direto',
            'Personalizado - Renda fixa',
            'Personalizado - Renda variável',
            'Moedas',
            'Cripto Moedas',
            'Ações',
            'Fundos de investimentos',
            'Conta corrente',
            'Imóveis',
            'Veículos'
        ],
        datasets: [
            {
                backgroundColor: [
                    documentStyle.getPropertyValue('--fixed-income-color'),
                    documentStyle.getPropertyValue('--fixed-income-color'),
                    documentStyle.getPropertyValue('--fixed-income-color'),
                    documentStyle.getPropertyValue('--fixed-income-color'),
                    documentStyle.getPropertyValue('--fixed-income-color'),
                    documentStyle.getPropertyValue('--variable-income-color'),
                    documentStyle.getPropertyValue('--variable-income-color'),
                    documentStyle.getPropertyValue('--variable-income-color'),
                    documentStyle.getPropertyValue('--variable-income-color'),
                    documentStyle.getPropertyValue('--variable-income-color'),
                    documentStyle.getPropertyValue('--cashflow-color'),
                    documentStyle.getPropertyValue('--properties-color'),
                    documentStyle.getPropertyValue('--vehicles-color')
                ],
                data: [
                    homeContext.fixedIncomeModel
                        .filter(f => f.mainType == AssetMainType.PrivateBound)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.fixedIncomeModel
                        .filter(f => f.mainType == AssetMainType.SavingAccount)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.fixedIncomeModel
                        .filter(f => f.mainType == AssetMainType.Debenture)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.fixedIncomeModel
                        .filter(f => f.mainType == AssetMainType.TreasureBound)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.fixedIncomeModel
                        .filter(f => f.mainType == AssetMainType.Customized)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.variableIncomeModel
                        .filter(f => f.mainType == AssetMainType.Customized)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.variableIncomeModel
                        .filter(f => f.mainType == AssetMainType.Currency)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.variableIncomeModel
                        .filter(f => f.mainType == AssetMainType.Cripto)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.variableIncomeModel
                        .filter(f => f.mainType == AssetMainType.Stock)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.variableIncomeModel
                        .filter(f => f.mainType == AssetMainType.InvestimentFunds)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.cashflowModel
                        .filter(f => f.mainType == AssetMainType.CheckingAccount)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.propertyModel
                        .filter(f => f.mainType == AssetMainType.Property)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                    homeContext.vehicleModel
                        .filter(f => f.mainType == AssetMainType.Vehicle)
                        .reduce((acc, item) => acc + item.asset.currentAmount, 0),
                ]
            }
        ]
    };
    const chartOptions = {
        animation: {
            duration: 0
        },
        plugins: {
            tooltip: {
                callbacks: {
                  label: function (context: any) {
                    const value = context.raw || 0;
                    const formattedValue = new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(value);

                    return ` ${formattedValue}`;
                  },
                },
            },
            legend: {
                labels: {
                    usePointStyle: true
                }
            }
        }
    };

    return (
        <Card
            isLoading={homeContext.isLoading}
        >
            <Container flexColumn fullWidth gap={3} className="flex-1" paddingVertical="3">
                <Container className="justify-content-between align-items-center">
                    <Text color="800" fontWeight="semibold">Subgrupo</Text>
                </Container>

                <Container center fullWidth>
                    <Chart 
                        type="pie" 
                        data={chartData} 
                        options={{ ...chartOptions, plugins: { ...chartOptions.plugins, legend: { ...chartOptions.plugins.legend, position: 'bottom' } } }}
                        className="w-26rem"
                    />
                </Container>
            </Container>
        </Card>
    );
}